import Echarts from "echarts";
const windowWidth = window.innerWidth;
let fontSize = windowWidth / 19; // 根据需要调整比例

function drawpillarChart(
  el,
  { dataX = [], dataValue = [], maxValueList = [] }
) {
  const myChart = Echarts.init(el);
  myChart.clear();
  const option = {
    backgroundColor: "#fff",
    tooltip: {
      trigger: "axis",
      textStyle: {
        color: "#fff"
      },
      formatter: function(params) {
        return params[1].name + "\n" + "\n" + params[1].value;
      }
    },
    grid: {
      left: "17%",
      right: "12%",
      top: "10%",
      bottom: "15%"
    },
    xAxis: {
      data: dataX,
      show: false,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#2D4377",
          opacity: 1
        }
      },
      axisLabel: {
        interval: 0,
        textStyle: {
          color: "#aaa",
          fontSize: 0.14 * fontSize
        },
        margin: 12 // 刻度标签与轴线之间的距离。
      }
    },
    yAxis: [
      {
        name: "",
        nameTextStyle: {
          align: "left",
          color: "#000",
          padding: [0, 0, 0, -20],
          fontSize: 0.14 * fontSize
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#2D4377",
            opacity: 0.5
          }
        },
        axisLabel: {
          textStyle: {
            color: "#aaa"
          },
          formatter: "{value}"
        }
      }
    ],
    legend: {
      top: "5%",
      left: "50%",
      textStyle: {
        color: "#aaa",
        fontSize: 0.14 * fontSize
      },

      itemGap: 12 // 设置间距
    },
    series: [
      {
        // 三个最低下的圆片
        name: "",
        type: "pictorialBar",
        symbolSize: [16, 10],
        symbolOffset: [0, 2],
        z: 12,
        itemStyle: {
          opacity: 1,
          color: "#0F32D2"
        },
        data: [0.5, 0.5, 0.5, 0.5, 0.5]
      },
      // 下半截柱状图
      {
        type: "bar",
        barWidth: 16,
        barGap: "-200%",
        itemStyle: {
          // lenged文本
          opacity: 0.7,
          color: function() {
            return new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "#1DC7FA" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#2564F4" // 100% 处的颜色
                }
              ],
              false
            );
          }
        },

        data: dataValue
      },

      {
        name: "",
        type: "pictorialBar",
        symbolSize: [16, 12],
        symbolOffset: [0, -4],
        z: 5,
        itemStyle: {
          opacity: 1,
          color: "#12AFED"
        },
        symbolPosition: "end",
        data: dataValue
      },
      {
        name: "", //头部
        type: "pictorialBar",
        symbolSize: [16, 10],
        symbolOffset: [0, -5],
        z: 12,
        symbolPosition: "end",
        itemStyle: {
          color: "#D4E6FA",
          opacity: 1
        },
        data: maxValueList
      },
      {
        name: "",
        type: "bar",
        barWidth: 16,
        barGap: "-100%",
        z: 0,
        itemStyle: {
          color: "#EAF3FC",
          opacity: 0.7
        },
        data: maxValueList
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    myChart.resize();
  });
}

function drawTopChart(el, { dataX = [], dataValue = [] }) {
  const myChart = Echarts.init(el);

  const option = {
    backgroundColor: "#fff",
    tooltip: {
      trigger: "axis",
      textStyle: {
        color: "#fff"
      },
      formatter: function(params) {
        return params[1].name + ":" + params[1].value;
      }
    },
    grid: {
      left: "12%",
      right: "12%",
      top: "10%",
      bottom: "15%"
    },
    xAxis: {
      data: dataX,
      show: false,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#2D4377",
          opacity: 1
        }
      },
      axisLabel: {
        interval: 0,
        textStyle: {
          color: "#aaa",
          fontSize: 14
        },
        margin: 12 // 刻度标签与轴线之间的距离。
      }
    },
    yAxis: [
      {
        name: "",
        nameTextStyle: {
          align: "left",
          color: "#000",
          padding: [0, 0, 0, -20],
          fontSize: 14
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#2D4377",
            opacity: 0.5
          }
        },
        axisLabel: {
          textStyle: {
            color: "#aaa"
          },
          formatter: "{value}"
        }
      }
    ],
    legend: {
      show: false,
      top: "5%",
      left: "50%",
      textStyle: {
        color: "#aaa",
        fontSize: 14
      },

      itemGap: 12 // 设置间距
    },
    series: [
      {
        // 三个最低下的圆片
        name: "",
        type: "pictorialBar",
        symbolSize: [16, 10],
        symbolOffset: [0, 2],
        z: 12,
        itemStyle: {
          opacity: 1,
          color: "#B67700"
        },
        data: [0.5, 0.5, 0.5, 0.5, 0.5]
      },
      // 下半截柱状图
      {
        type: "bar",
        barWidth: 16,
        barGap: "-200%",
        itemStyle: {
          // lenged文本
          opacity: 0.7,
          color: function() {
            return new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "#FFD692" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#FFB11B" // 100% 处的颜色
                }
              ],
              false
            );
          }
        },

        data: dataValue
      },

      {
        name: "",
        type: "pictorialBar",
        symbolSize: [16, 12],
        symbolOffset: [0, -4],
        z: 5,
        itemStyle: {
          opacity: 1,
          color: "#FFB42C"
        },
        symbolPosition: "end",
        data: dataValue
      },
      {
        name: "", //头部
        type: "pictorialBar",
        symbolSize: [16, 10],
        symbolOffset: [0, -5],
        z: 12,
        symbolPosition: "end",
        itemStyle: {
          color: "#FCE8B7",
          opacity: 1
        },
        data: [100, 100, 100, 100, 100]
      },
      {
        name: "",
        type: "bar",
        barWidth: 16,
        barGap: "-100%",
        z: 0,
        itemStyle: {
          color: "#FCF2D6",
          opacity: 0.7
        },
        data: [100, 100, 100, 100, 100]
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    myChart.resize();
  });
}

function drawPillarLineChart(el, { dateList, frontDate, afterDate }) {
  console.log(0.18 * fontSize);
  const myChart = Echarts.init(el);
  const option = {
    //你的代码
    backgroundColor: "#fff",
    title: {
      text: "省内冷藏车月均里程数对比",
      left: "10",
      top: "10",
      textStyle: {
        fontSize: 0.18 * fontSize
      }
    },
    tooltip: {
      backgroundColor: "rgba(13, 64, 71, 0.50)",
      borderColor: "rgba(143, 225, 252, 0.60)",
      padding: 8,
      textStyle: {
        color: "#fff"
      }
    },
    legend: {
      data: ["去年", "今年", "公里"],
      right: 10,
      top: 10,
      textStyle: {
        fontSize: 14,
        color: "#000"
      }
    },
    grid: {
      left: "10%",
      right: "5%",
      top: "25%",
      bottom: "10%"
    },
    xAxis: [
      {
        type: "category",
        data: dateList,
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          // 轴线设置
          show: true, // 显示轴线
          lineStyle: {
            // 轴线样式设置
            color: "#C5C5C5", // 轴线颜色
            width: 1, // 轴线宽度
            type: "solid" // 轴线类型-虚线
          }
        },
        axisLabel: {
          textStyle: {
            color: "#000", //更改坐标轴文字颜色
            fontSize: 12 //更改坐标轴文字大小
          }
        }
      }
    ],
    yAxis: [
      {
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        },
        axisLabel: {
          textStyle: {
            color: "#000", //更改坐标轴文字颜色
            fontSize: 12 //更改坐标轴文字大小
          }
        }
      },
      // 折线部分
      {
        type: "value",
        name: "",
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#F5F5F5", //更改坐标轴文字颜色
            fontSize: 12 //更改坐标轴文字大小
          },
          formatter: "{value}"
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        }
      }
    ],
    series: [
      // 数据的柱状图1
      {
        name: "公里",
        type: "bar",
        barWidth: 12,
        z: 10,
        barGap: "-300%",
        itemStyle: {
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            0,
            1,
            0,
            0,
            [
              {
                offset: 1,
                color: "#1DC7FA" // 0% 处的颜色
              },
              {
                offset: 0,
                color: "#2564F4" // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: frontDate
      },
      // 数据的柱状图2
      {
        name: "公里",
        type: "bar",
        barWidth: 12,
        z: 10,
        barGap: "50%",
        itemStyle: {
          // lenged文本
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            //前4个参数用于配置渐变色的起止位置，这4个参数依次对应右/下/左/上四个方位，而0 0 0 1则代表渐变色从正上方开始。
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#FFD692" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#FFB11B" // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: afterDate
      },
      // 折线部分1
      {
        name: "去年",
        type: "line",
        yAxisIndex: 1,
        symbol: "circle",
        symbolSize: 10,
        itemStyle: {
          shadowBlur: 0,
          color: "#ED4B69"
        },
        label: {
          show: false,
          position: "top"
        },
        areaStyle: {
          normal: {
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(237,75,105,.3)"
                },
                {
                  offset: 1,
                  color: "rgba(174, 112, 79, 0)"
                }
              ],
              false
            )
          }
        },
        data: frontDate
      },
      // 折线部分2
      {
        name: "今年",
        type: "line",
        yAxisIndex: 1,
        symbol: "circle",
        symbolSize: 10,
        itemStyle: {
          shadowBlur: 0,
          color: "#1D56F0"
        },
        label: {
          show: false,
          position: "top"
        },
        areaStyle: {
          normal: {
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(29,86,240,.3)"
                },
                {
                  offset: 1,
                  color: "rgba(174, 112, 79, 0)"
                }
              ],
              false
            )
          }
        },
        data: afterDate
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    console.log(1111);
    myChart.resize();
  });
}

function drawDashBoardChart(el, rateValue, { title }) {
  const myChart = Echarts.init(el);

  const demoData = [
    {
      name: "",
      value: rateValue
    }
  ];
  const option = {
    backgroundColor: "#fff",
    series: (function() {
      var result = [];
      demoData.forEach(function(item) {
        result.push(
          {
            name: "背景圈",
            type: "gauge",
            radius: "85%",
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              roundCap: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[1, "#ddd"]],
                width: 20
              }
            },
            splitLine: {
              //分隔线样式
              show: false
            },
            axisLabel: {
              //刻度标签
              show: false
            },
            pointer: {
              show: false
            },
            axisTick: {
              //刻度样式
              show: false
            },
            detail: {
              show: false,
              offsetCenter: [0, "60%"],
              textStyle: {
                fontSize: 32,
                color: "#fff"
              },
              formatter: function() {
                return "SO2";
              }
            }
          },
          {
            type: "gauge",
            radius: "90%",
            min: 10,
            max: 100,
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              roundCap: true,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(0,0,0,0)"]]
              }
            }, //仪表盘轴线
            axisTick: {
              show: true,
              lineStyle: {
                color: "#ddd",
                width: 1
              },
              length: -8
            }, //刻度样式
            splitLine: {
              show: true,
              length: -20,
              lineStyle: {
                color: "#ddd"
              }
            }, //分隔线样式
            axisLabel: {
              show: false
            },
            pointer: {
              show: 0
            },
            detail: {
              show: 0
            }
          },
          // 最外层含中间数据
          {
            name: item.name,
            type: "gauge",
            radius: "85%",
            axisLine: {
              show: true,
              roundCap: true,
              lineStyle: {
                width: 20,
                color: [
                  [
                    item.value / 100,
                    new Echarts.graphic.LinearGradient(0, 1, 1, 0, [
                      {
                        offset: 0,
                        color: "#37BC67"
                      },
                      {
                        offset: 0.5,
                        color: "#F0F61E"
                      },
                      {
                        offset: 0.6,
                        color: "#FFA41F"
                      },
                      {
                        offset: 0.8,
                        color: "red"
                      },
                      {
                        offset: 1,
                        color: "#FFA41F"
                      }
                    ])
                  ],
                  [1, "rgba(255,255,255,.0)"]
                ]
              }
            },
            axisTick: {
              show: 0
            },
            splitLine: {
              show: 0
            },
            axisLabel: {
              show: 0
            },
            pointer: {
              show: false
            },
            detail: {
              offsetCenter: ["0", "50%"],
              textStyle: {
                fontSize: 16,
                color: "#000"
              },
              formatter: function(value) {
                return value + "%" + "\n" + "\n" + "\n" + title;
              }
            },
            itemStyle: {
              // color: 'rgba(255, 36, 74,.3)',
            },
            data: [
              {
                value: item.value
              }
            ]
          }
        );
      });
      return result;
    })()
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    myChart.resize();
  });
}

function resizeEcharts() {
  window.addEventListener("resize", function() {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 19; // 根据需要调整比例
  });
}

export default {
  drawpillarChart,
  drawTopChart,
  drawPillarLineChart,
  drawDashBoardChart,
  resizeEcharts
};
